import i18n from "@/i18n";

import {
  type SystemMessage,
  renderSystemMessage,
} from "@/lib/system-message-core";

/**
 * Render a system line — group or one-to-one — in the READER's language.
 *
 * The server writes these once and every reader reads them in one of seven
 * languages, so it names the line with a key rather than shipping a sentence,
 * and this turns the pair back into text here, where the reader's language is
 * known. `content` is the English the server rendered alongside it, and it is
 * the fallback for two real cases:
 *
 *   - group rows written before the server stored keys, which exist in
 *     production and carry nothing to derive a key from;
 *   - a key this build does not have, which is what a client one release
 *     behind the API sees.
 *
 * Both must show something rather than nothing, which is why `content` is
 * still written and still sent.
 *
 * The chat side has no first case: `presentMessageForViewer` derives the key
 * from the stored text on every read, so rows written years ago resolve too.
 * The second case is real for both.
 */
export function systemMessageText(message: SystemMessage): string {
  return renderSystemMessage(message, (key, params) => i18n.t(key, params));
}
